var React = require('react');

function Tortilla4Inline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"147.9","cy":"197","r":"25.9","key":0}),React.createElement("circle",{"cx":"65","cy":"65","r":"65","key":1})]);
}

Tortilla4Inline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 173.8 222.9","style":{"enableBackground":"new 0 0 173.8 222.9"},"xmlSpace":"preserve"};

module.exports = Tortilla4Inline;

Tortilla4Inline.default = Tortilla4Inline;
